export enum PeriodStatus {
    VALIDATED = 0, // the period has been uploaded validated and the change set has been generated. The period is valid
    INVALID = 1, // the period has been validated, but is invalid. E.g VIN is not unique, ARE does not match cost center,...
    ACCOUNTANT_DENIED = 2, // the period has been denied by the accountant
    SUBMITTED = 3, // the period has been submitted by the SCM. If the accountant does not deny it afterwards, this will be the final status
    ACCOUNTANT_APPROVED = 4 // the period has been approved by the accountant
}
